<!-- eslint-disable -->
<template>
  <CommonPages id="home" :class="['home']" :titlePrefix="'Home'"
    :metaDescription="domainConfig?.['meta']?.des || 'Default des'">
    <HomeBanner />
    <AdComponent v-if="deviceType == 'mobile'"
      v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.home_2" ref="ads-home-2"
      class="ad-width-100 m_padding" :ads="adsensConfig?.home_2" :showDebug="showDebug" />

    <HomeCalculator />
    <div class="dashed-line">
      <div class="dashed-line-item"></div>
    </div>

    <AdComponent v-if="deviceType != 'mobile'"
      v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.home_1" ref="ads-home-1"
      class="ad-width-100 pc_padding" :ads="adsensConfig?.home_1" :showDebug="showDebug" />

    <HomeLenders />
    <AdComponent v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.home_4"
      ref="ads-home-4" class="ad-width-100 m_padding pc_padding" :ads="adsensConfig?.home_4"
      :showDebug="showDebug" />

    <div class="dashed-line">
      <div class="dashed-line-item"></div>
    </div>
    <HomeCredit />
    <AdComponent v-if="deviceType == 'mobile'"
      v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.home_5" ref="ads-home-5"
      class="ad-width-100 m_padding" :ads="adsensConfig?.home_5" :showDebug="showDebug" />
    <div class="dashed-line">
      <div class="dashed-line-item"></div>
    </div>
    <HomeAbout />

  </CommonPages>
</template>

<script>
import common from '@/mixin/common.js'
import adMixin from '@/mixin/adMixin.js'
import adTrackingMixin from '@/mixin/adTrackingMixin.js'
import { mapGetters } from 'vuex';
import CommonPages from '@/pages/components/page_common.vue'
import HomeBanner from '@/components/HomeBanner.vue'
import HomeCalculator from '@/components/HomeCalculator.vue'
import HomeLenders from '@/components/HomeLenders.vue'
import HomeCredit from '@/components/HomeCredit.vue'
import HomeAbout from '@/components/HomeAbout.vue'
import AdComponent from '@/pages/components/AdComponent.vue'

import '@/css/home.scss';
import '@/css/common.scss';

export default {
  name: 'Home',
  components: {
    CommonPages,
    HomeBanner,
    HomeCalculator,
    HomeLenders,
    HomeCredit,
    HomeAbout,
    AdComponent
  },
  mixins: [common, adMixin, adTrackingMixin],
  data () {
    return {

    };
  },
  computed: {
    ...mapGetters([
      "adsensConfig",
      'adPosConfig',
      'deviceType',
      'domainConfig',
      'showDebug'
    ]),
  },
  async activated () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Home] Component activated`);
    }

  },
  async mounted () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Home] Component mounted`);
    }

    // Manually report page view for home page to ensure it happens before ad initialization
    await this.reportPageView();
    // The new adMixin handles its own initialization, so these calls are no longer needed here.
    // await this.initAdSystem();
    // this.$nextTick(() => {
    //   this.initAdTracking();
    // });
  },
  deactivated () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Home] Component deactivated`);
    }
  },
  beforeDestroy () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Home] Component beforeDestroy`);
    }
  },
  methods: {

  }
};
</script>

